const CloseIcon = () => {
  return (
    <div className="border-primary relative h-6 w-8">
      <div className="bg-primary absolute top-1/2 left-0 h-1 w-full -translate-y-1/2 rotate-45"></div>
      <div className="bg-primary absolute top-1/2 left-0 h-1 w-full -translate-y-1/2 -rotate-45"></div>
    </div>
  );
};

export default CloseIcon;
